// Import Flickity module
import {
  initFlickity,
  createFlickity,
  whenFlickityReady,
  setupArrowNavigation,
  setupClickHandlers,
} from "../modules/flickity.js";

// Initialize partners carousel
const initPartners = async () => {
  const toggleImageColor = (element, toColor) => {
    const replaceColor = (attr) => {
      if (typeof attr !== "undefined") {
        return attr.replace(
          toColor ? "grey" : "color",
          toColor ? "color" : "grey"
        );
      }
    };

    element.attr("src", (_, attr) => replaceColor(attr));
    element.siblings("source").attr("srcset", (_, attr) => replaceColor(attr));
  };

  const partners = await createFlickity(".partners-list>.slides", {
    cellAlign: "center",
    groupCells: 4,
    autoPlay: 5000,
    pageDots: false,
    lazyLoad: 2,
    on: {
      ready: function () {
        $(".partners-list>.slides .item")
          .on("mouseenter", "img", function () {
            toggleImageColor($(this), true);
          })
          .on("mouseleave", "img", function () {
            toggleImageColor($(this), false);
          });
      },
    },
  });

  if (!partners) return;

  // Setup arrow navigation
  setupArrowNavigation(partners, ".partners-list");
};

// Initialize when DOM is ready and Flickity is available
$(document).ready(() => {
  whenFlickityReady(initPartners);
});
